import { getQueryParamByName } from '@/lib/url/query-params';

/**
 * Campaign the visitor came in with, e.g. the print mailing a QR code was
 * printed on. Read once on load: the assistant is a sidebar living inside the
 * host page, whose URL may well change while the assistant stays mounted.
 */
const campaign = getQueryParamByName('utm_campaign');

export const getCampaign = (): string | null => campaign || null;

/**
 * Appends the campaign to the request comment, so it reaches the sales rep in
 * the notification mail. Returns the comment unchanged if the visitor did not
 * come in through a campaign.
 */
export const withCampaign = (comment: string): string => {
  const campaignId = getCampaign();
  if (!campaignId) {
    return comment;
  }

  return `${comment}\n### Kampagne\n\n${campaignId}\n`;
};
